import { mockAnnouncementsData } from "../data/mockData/wlDemoData";

const OVERRIDES_KEY = "wl_bs_announcement_overrides";

function readJson(key, fallback) {
  if (typeof sessionStorage === "undefined") {
    return fallback;
  }
  try {
    const raw = sessionStorage.getItem(key);
    if (raw == null) {
      return fallback;
    }
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

function writeJson(key, value) {
  if (typeof sessionStorage === "undefined") {
    return;
  }
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch {
    // no-op
  }
}

export function clearDemoAnnouncementsSessionStorage() {
  if (typeof sessionStorage === "undefined") {
    return;
  }
  sessionStorage.removeItem(OVERRIDES_KEY);
}

export function getAnnouncementOverridesMap() {
  const map = readJson(OVERRIDES_KEY, {});
  return map && typeof map === "object" && !Array.isArray(map) ? map : {};
}

function writeAnnouncementOverride(id, patch) {
  if (id == null || !patch || typeof patch !== "object") {
    return;
  }
  const sid = String(id);
  const overrides = getAnnouncementOverridesMap();
  overrides[sid] = { ...(overrides[sid] || {}), ...patch };
  writeJson(OVERRIDES_KEY, overrides);
}

export function getMergedAnnouncements(seedRows = mockAnnouncementsData) {
  const overrides = getAnnouncementOverridesMap();
  return (seedRows || []).map(row => {
    if (!row || row.id == null) {
      return row;
    }
    const patch = overrides[String(row.id)];
    return patch ? { ...row, ...patch } : row;
  });
}

export function buildAnnouncementsOverview(seedRows = mockAnnouncementsData) {
  const merged = getMergedAnnouncements(seedRows);
  const visible = merged.filter(row => !row.is_dismissed);
  return {
    count: visible.length,
    unread_count: visible.filter(row => !row.is_read).length,
    results: visible,
  };
}

export function markDemoAnnouncementRead(announcementId) {
  writeAnnouncementOverride(announcementId, { is_read: true });
}

export function dismissDemoAnnouncement(announcementId) {
  writeAnnouncementOverride(announcementId, { is_dismissed: true, is_read: true });
}

export function dismissAllDemoAnnouncements(seedRows = mockAnnouncementsData) {
  (seedRows || []).forEach(row => {
    if (row?.id != null) {
      writeAnnouncementOverride(row.id, { is_dismissed: true, is_read: true });
    }
  });
}
